import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { Button } from 'components/elements'
import SearchFilterPopUp from '../searchTippyPopup/searchTippyPopUp'
import { PAGE_FILTER_SHORT_NAME } from '../pagination/paginationFilterConfig'
import {
  sortByDefault,
  SORTBY_FILTER_SHORT_NAME,
  isSortByDefault,
} from './sortByFilterConfig'
import './../../../theme/assets/styles/updated.sass'

import { addToUrlPush, removeFromUrlPush } from '../filterUtil.js'
import SortByInput from '../filterInputs/sortByInput'

let classNames = require('classnames')

class SortByFilter extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      buttonLabel: "Sort by",
      currentSortBy: this.props.currentSortBy,
      active: isSortByDefault(this.props.currentSortBy) ? false : true,
    }
  }

  componentDidMount() {
    //we might grab the URL here on mount. but I don't know if we should or not.
    //might pass these down as defaultValue props.
  }

  componentDidUpdate(prevProp) {
    if (prevProp.currentSortBy !== this.props.currentSortBy) {
      this.setState({
        currentSortBy: this.props.currentSortBy,
        buttonLabel: "Sort by",
        active: isSortByDefault(this.props.currentSortBy) ? false : true,
      })
    }
  }

  handleApply = () => {
    this.closeFilter()
    let tempLocationSearch = this.props.location.search
    if (this.props.location.search?.includes('&page=')) {
      const { string } = removeFromUrlPush(
        [PAGE_FILTER_SHORT_NAME],
        tempLocationSearch
      )
      tempLocationSearch = string
    }
    if (isSortByDefault(this.state.currentSortBy)) {
      this.setState({ active: false })
      let newQueryString = removeFromUrlPush(
        [SORTBY_FILTER_SHORT_NAME],
        tempLocationSearch
      )
      this.props.history.push('?' + newQueryString.string)
    } else {
      this.setState({ active: true })
      let valuesToAdd = [
        { key: SORTBY_FILTER_SHORT_NAME, value: this.state.currentSortBy },
      ]
      let newQueryString = addToUrlPush(valuesToAdd, tempLocationSearch)
      this.props.history.push('?' + newQueryString.string)
    }
    this.setState({
      // buttonLabel: buildPriceLabel('short', this.state.currentRange),
    })
    this.props.onApply(this.state.currentSortBy)
  }

  handleOpen = () => {
    this.setState({ open: true })
    this.props.onOpen()
  }

  closeFilter = () => {
    this.setState({ open: false })
    this.props.onClose()
  }

  handleSortByChange = (value) => {
    this.setState({
      currentSortBy: value,
    })
  }

  render() {
    const { open, buttonLabel, currentSortBy, active } = this.state

    let filterBtnClass = classNames(
      'filterBtnClass filters-bar-buttons',
      this.props.className,
      {
        'is-primary': active || open,
      }
    )

    return (
      <SearchFilterPopUp
        triggerClassName={filterBtnClass}
        triggerText={
          <>
            <span>
              {buttonLabel}
            </span>
            <span className="icon mt-1">
              &nbsp;<i className="fa fa-angle-down"></i>
            </span>
          </>
        }
        on="click"
        open={open}
        onClose={() => this.closeFilter()}
        onOpen={() => this.handleOpen()}
      >
        <div className="search-filter-inner-wrapper">
          <SortByInput
            onChange={this.handleSortByChange}
            selectedRadio={currentSortBy}
          />
          <div className="has-text-right search-filter-apply-btn">
            <Button onClick={this.handleApply}>Apply</Button>
          </div>
        </div>
      </SearchFilterPopUp>
    )
  }
}
export default withRouter(SortByFilter)

SortByFilter.defaultProps = {
  currentSortBy: sortByDefault,
  onApply: function () { },
  onOpen: function () { },
  onClose: function () { },
  onClear: function () { },
  pushToUrl: true,
}
